/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import Cookies from 'js-cookie';
import { useCallback, useMemo } from 'react';

const useLogin = () => {
  const cookie = useMemo(() => {
    const existingCookie = Cookies.get('kmw-forum');
    if (existingCookie) return JSON.parse(existingCookie);
    return;
  }, []);

  const setCookie = useCallback((newCookie) => {
    Cookies.set('kmw-forum', newCookie, { expires: 1 });
  }, []);

  const clearCookie = useCallback(() => {
    Cookies.remove('kmw-forum');
  }, []);

  return [cookie, setCookie, clearCookie];
};

export default useLogin;
